import { UserDetails } from "../userDetails/getUserDetails";
import { ContactInfo } from "../../../components/create-service-case/stores/apiStore";

export const mapUserDetailsToContactInfo = (userDetails: UserDetails): ContactInfo => {
    return {
        salutation: getSalutation(userDetails.salutation),
        firstName: userDetails.firstname,
        lastName: userDetails.surname,
        email: userDetails.email,
        phone: userDetails.phone
    };
};

const getSalutation = (salutation: string | null): number | null => {
    if (typeof salutation === "string") {
        const parsed = parseInt(salutation, 10);
        return isNaN(parsed) ? null : parsed;
    }
    return null;
};
